import { RetencaoVeiculoFiltroService } from './retencao-veiculo-filtro.service';

export class FiltroCategoriaOs {

    categorias = [];

    constructor(private servico: RetencaoVeiculoFiltroService) { }

    carregar(): any {
        this.servico.getFiltroCategorias()
            .then(r => {
                this.preencher(r.dados);
                return this.categorias;
            });
    }


    public selecionados(): any {
        let selecionados = [];
        const idsFiltrados = [1, 2, 3, 4, 7, 8, 11, 12];
        let categoriasIdFiltrados = this.categorias.filter(el => idsFiltrados.includes(el.id));
        
        selecionados = categoriasIdFiltrados.filter(m => m.selecionado).map(m => m);

        return selecionados;
    }

    public naoSelecionados(): any {
        let selecionados = [];
        const idsFiltrados = [1, 2, 3, 4, 7, 8, 11, 12];
        let categoriasIdFiltrados = this.categorias.filter(el => idsFiltrados.includes(el.id));

        selecionados = categoriasIdFiltrados.filter(m => !m.selecionado).map(m => m);
        
        return selecionados;
    }

    private preencher(dados: any) {
        this.inserirItens(dados);
    }

    private inserirItens(dados: any) {
        dados.forEach(categoria => {
            const i: number = this.categorias.map(m => m.id).indexOf(categoria.id);
            if (i < 0) {
                const item = {
                    'id': categoria.id,
                    'descricao': categoria.descricao,                    
                    'toDescricao': function () { return this.descricao },
                    'selecionado': false
                };
                this.categorias.push(item);
            }
        });
    }
}
